import request from '../../untils/request';

// 获取商户编号
export function selectListLessee(data) {
  return request({
    url: '/lessee/selectList',
    method: 'get',
    params: data,
  });
}

// 解除绑定 销户查询列表
export function selectListUnbind(data) {
  return request({
    url: '/cancelAccount/selectList',
    method: 'get',
    params: data,
  });
}
// 销户
export function cancelAccount(data) {
  return request({
    url: '/cancelAccount/cancelAccount',
    method: 'get',
    params: data,
  });
}
// 解绑电表
export function unBindMeter(data) {
  return request({
    url: '/cancelAccount/unBindMeter',
    method: 'post',
    data: data,
  });
}
// 解绑水表
export function unBindWater(data) {
  return request({
    url: '/cancelAccount/unBindWater',
    method: 'post',
    data: data,
  });
}
// 获取商户名称下拉列表
export function selectListLesseeName(data) {
  return request({
    url: '/lessee/selectList',
    method: 'get',
    params: data,
  });
}